import $http from '../http';
let complaintPath = '/tio/complain/v2/api/';

// 查询不予受理原因
export const getReasonList = data => {
  return $http({
      url: complaintPath + 'complaint/publicCondition/getReasonList',
      data,
      method: 'POST'
  });
};

// 退回12301提交
export const rollback = data => {
    return $http({
        url: complaintPath + 'rollback',
        data,
        method: 'POST'
    });
  };

// 自行和解
export const selfSupplement = data => {
  return $http({
      url: complaintPath + 'finishFeedback/selfSupplement',
      data,
      method: 'POST'
  });
};
// export const selfSupplement = data => {
//     return $http({
//         url: complaintPath + 'finishInformation/selfSupplement',
//         data,
//         method: 'POST'
//     });
//   };

// 调解成功
export const successSupplement = data => {
  return $http({
      url: complaintPath + 'finishFeedback/successSupplement',
      data,
      method: 'POST'
  });
};
// export const successSupplement = data => {
//     return $http({
//         url: complaintPath + 'finishInformation/successSupplement',
//         data,
//         method: 'POST'
//     });
//   };

// 调解失败
export const failSupplement = data => {
  return $http({
      url: complaintPath + 'finishFeedback/failSupplement',
      data,
      method: 'POST'
  });
};
// export const failSupplement = data => {
//     return $http({
//         url: complaintPath + 'finishInformation/failSupplement',
//         data,
//         method: 'POST'
//     });
//   };

// 启用质保金补偿
export const warrantySupplement = data => {
    return $http({
        url: complaintPath + 'finishFeedback/warrantySupplement',
        data,
        method: 'POST'
    });
  };
  // export const warrantySupplement = data => {
  //   return $http({
  //       url: complaintPath + 'finishInformation/warrantySupplement',
  //       data,
  //       method: 'POST'
  //   });
  // }; 
  // 原投诉单信息 ==》 调解书自动补充内容接口
  export const getAutoWriteInfo = data => {
    return $http({
        url: complaintPath + 'finishFeedback/getAutoWriteInfo',
        data,
        method: 'POST'
    });
  };
// export const getAutoWriteInfo = data => {
//     return $http({
//         url: complaintPath + 'finishInformation/getAutoWriteInfo',
//         data,
//         method: 'POST'
//     });
//   };

// 上传附件
export const fileUpload = data => {
  return $http({
      url: complaintPath + 'fileUpload',
      data,
      method: 'POST'
  });
};

// 上传附件
export const detailsInfo = data => {
  return $http({
      url: complaintPath + 'qywx/details/info',
      data,
      method: 'POST'
  });
};

export default {
    getReasonList,
    rollback,
    selfSupplement,
    successSupplement,
    failSupplement,
    warrantySupplement,
    getAutoWriteInfo,
    fileUpload,
    detailsInfo
};
